import { useCallback } from 'react';
import { Select, MultiSelect, TextInput } from '@components/atoms';

export const useComponent = () => {
  const getComponent = useCallback(as => {
    return {
      Select: () => Select,
      MultiSelect: () => MultiSelect,
      TextInput: () => TextInput,
    }[as]();
  }, []);
  return {
    getComponent,
  };
};
